import { FaPlus } from "react-icons/fa";
import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Pagination from "../../shared/components/Pagination";
import SideModal from "../../shared/components/general/SideModal";
import useFetchAdmins from "../../shared/api/teachers/useFetchAdmins";
import AdminsTable from "../../shared/components/teachers/AdminsTable";
import AdminDetails from "../../shared/components/teachers/AdminDetails";
import AdminTableOverview from "../../shared/components/teachers/AdminTableOverview";
import useFetchTeacherBasicInfo from "../../shared/api/teachers/useFetchTeacherBasicInfo";
import NewAdmin from "../../shared/components/teachers/NewAdmin";
import RemoveAdmin from "../../shared/components/teachers/RemoveAdmin";

export default function Admins() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const userId = query.get("selected");
    const action = query.get("action");

    const { schoolId } = useParams();
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState(null);

    const { data: details, loading: loadingTeacher } =
        useFetchTeacherBasicInfo(userId);

    const {
        loading,
        data: admins,
        request: getAdmins,
    } = useFetchAdmins(schoolId, page, setPagination);

    console.log(admins, "=== admins ====");
    console.log(pagination, "=== pagination ====");

    async function closeSideModal(params) {
        navigate(`/${schoolId}/admins`);

        if (params?.refresh) await getAdmins();
    }

    function handleRemoveAdmin() {
        navigate(`/${schoolId}/admins?selected=${userId}&action=remove-admin`);
    }

    return (
        <div className={userId || action ? "page" : "full_page"}>
            <div className="mb-5 flex items-center justify-between">
                <div className="page_title_container">
                    <h1 className="page_title">Admins</h1>
                </div>

                <button
                    className="flex items-center justify-center gap-1 bg-primary h-8 xxs:h-8 ssm:h-9 rounded-sm text-white px-3 min-w-[80px]"
                    onClick={() =>
                        navigate(`/${schoolId}/admins?action=new-admin`)
                    }
                >
                    <FaPlus className="text-sm" />
                    <small>Invite Admin</small>
                </button>
            </div>

            <div className="main_content">
                <AdminTableOverview total={pagination?.totalDocuments} />

                <AdminsTable data={admins} loading={loading} userId={userId} />

                <Pagination setPage={setPage} pagination={pagination} />
            </div>

            <SideModal
                isVisible={userId || action}
                closeSideModal={closeSideModal}
            >
                {userId && !action ? (
                    <AdminDetails
                        details={details}
                        loading={loadingTeacher}
                        handleRemoveAdmin={handleRemoveAdmin}
                    />
                ) : null}

                {action === "new-admin" ? (
                    <NewAdmin closeSideModal={closeSideModal} />
                ) : null}

                {action === "remove-admin" ? (
                    <RemoveAdmin
                        closeSideModal={closeSideModal}
                        details={details}
                        loading={loadingTeacher}
                    />
                ) : null}
            </SideModal>
        </div>
    );
}
